import BadgeNext from "ds/components/BadgeNext";
import { BadgeVariants } from "ds/components/BadgeNext/types";
import { NotificationSeverity } from "types/generated";

type NotificationSeverityBadgeVariant = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const NOTIFICATION_SEVERITIES: Record<
  NotificationSeverity,
  NotificationSeverityBadgeVariant
> = {
  [NotificationSeverity.Error]: { variant: "red", text: "Error" },
  [NotificationSeverity.Info]: { variant: "blue", text: "Info" },
  [NotificationSeverity.Warning]: { variant: "yellow", text: "Warning" },
};

type NotificationSeverityBadgeProps = {
  severity: NotificationSeverity;
  className?: string;
};

const NotificationSeverityBadge = ({ severity, className }: NotificationSeverityBadgeProps) => {
  if (!NOTIFICATION_SEVERITIES[severity]) {
    return null;
  }

  return (
    <BadgeNext
      variant={NOTIFICATION_SEVERITIES[severity].variant}
      type="strong"
      className={className}
      text={NOTIFICATION_SEVERITIES[severity].text}
    />
  );
};

export default NotificationSeverityBadge;
